<task-timer
    *ngIf="userTaskTimer"
    [dueOn]="userTaskTimer.DueOn"
    [state]="'badge'"
    background="dark"
    (timerClicked)="onTaskTimerClick()"
    [taskTimer]="userTaskTimer"
>
</task-timer>